module.exports = __webpack_public_path__ + "static/media/select.54e0fc10.svg";